<template>
  <div class="type-manage">
    <div class="header"><span>类型管理</span></div>
    <div class="filter">
      <el-input
        style="margin-right: 16px; width: 200px"
        v-model="formSearch.search"
        placeholder="请输入类型名称"
      ></el-input>
      <el-select
        style="margin-right: 16px"
        v-model="formSearch.types"
        filterable
        clearable
        multiple
        collapse-tags
        class="filter-item all-select"
        placeholder="请选择类型"
        popper-class="BI-select BI-select-product"
      >
        <el-option
          v-for="item in platformList"
          :label="item.name"
          :value="item.id"
          :key="item.id"
        ></el-option>
      </el-select>
      <el-select
        clearable
        v-model="formSearch.operatorIds"
        filterable
        multiple
        collapse-tags
        class="filter-item all-select"
        placeholder="请选择编辑人"
        popper-class="BI-select BI-select-product"
      >
        <el-option
          v-for="item in operatorsOptions"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
      <el-button @click="handleReset">重置</el-button>
      <el-button @click="handleSearch" type="primary">查询</el-button>
      <el-button @click="addType" type="primary">新建类型</el-button>
    </div>

    <div class="table">
      <el-table
        :border="false"
        id="rebateSetTable"
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        height="100%"
      >
        <el-table-column
          v-for="item of columns"
          :label="item.label"
          :key="item.prop"
          :prop="item.prop"
          :width="item.width"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'operate'">
              <el-button type="text" @click="editTag(scope.row)">编辑</el-button>
              <el-button type="text" @click="deleteTag(scope.row)">删除</el-button>
            </div>
            <span v-else> {{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <self-pagination
        :total="pageData.total"
        :pageSize="pageData.size"
        :currentPage="pageData.page"
        ref="tabelPagination"
        @getCurrentPage="changePage"
        @handleSizeChange="changePageSize"
      ></self-pagination>
    </div>
    <add-type-modal ref="typeModal" @callBackSuccess="handleSearch"></add-type-modal>
  </div>
</template>

<script>
import { columns } from "./config";
import { materialFieldsObj } from "@/config/fieldData";
import AddTypeModal from "./AddTypeModal.vue";
import {
  getTagPropertyList,
  delTagProperTY,
  getTagPropertyOperator,
  getPlatformType,
} from "@/api/property.js";
export default {
  components: {
    AddTypeModal,
  },
  data() {
    return {
      formSearch: {
        search: "",
        types: [],
        operatorIds: [],
      },
      materialFieldsObj,
      operatorsOptions: [],
      columns,
      tableData: [],
      loading: false,
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      fileList: [], //上传的文件列表
      platformList: [],
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.getList();
    getTagPropertyOperator().then((res) => {
      this.operatorsOptions = res.data;
    });
    getPlatformType().then((res) => {
      this.platformList = res.data;
    });
  },

  methods: {
    changePage(page) {
      this.pageData.page = page;
      this.getList();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getList();
    },
    getList() {
      const { operatorIds, types, search } = this.formSearch;
      getTagPropertyList({
        pageSize: this.pageData.size,
        page: this.pageData.page,
        operatorIds,
        types,
        search,
      }).then((res) => {
        this.tableData = res.data.list;
        this.pageData.total = res.data.total;
      });
    },
    handleReset() {
      this.formSearch = {
        search: "",
        types: [],
        operatorIds: [],
      };
      this.pageData.page = 1;
      this.getList();
    },
    handleSearch() {
      this.pageData.page = 1;
      this.getList();
    },
    addType() {
      this.$refs.typeModal.openModal("add");
    },
    editTag(data) {
      this.$refs.typeModal.openModal("edit", data);
    },
    deleteTag(record) {
      this.$confirm("确定删除该类型?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delTagProperTY({ id: record.id }).then((res) => {
            if (res.code == "0000") {
              this.$message.success("删除成功");
              this.handleSearch();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="less">
.type-manage {
  border-radius: 4px;
  margin: 16px;
  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.15);
  height: calc(~"100% - 38px");
  background: #ffffff;
  .header {
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    color: rgba(24, 144, 255, 1);
    padding-left: 25px;
  }
  .filter {
    display: flex;
    margin: 16px 20px;
    .filter-item {
      margin-right: 16px;
      /deep/ .el-input__inner {
        height: 32px !important;
      }
    }
  }
  .table {
    height: calc(100% - 175px);
    margin: 20px;
  }
}
</style>
